import { FunctionComponent } from 'react';

export const Logo: FunctionComponent = () => {
  return <img className="w-[150px] drop-shadow-xl" src="/images/logo.png" />;
};
